import { render } from "./CategoryCommission.vue?vue&type=template&id=7672f0cd&scoped=true"
import script from "./CategoryCommission.vue?vue&type=script&lang=js"
export * from "./CategoryCommission.vue?vue&type=script&lang=js"

import "./CategoryCommission.vue?vue&type=style&index=0&id=7672f0cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7672f0cd"]])

export default __exports__